import "./js/index.js";

// //components
// import "./components/Header/index.js";
// import "./components/Header/search.js";
// import "./components/Footer/index.js";
import "./components/MainSlider/index.js";
import "./components/ReviewCard/index.js";
// import "./components/MainProductCard/index.js";
// import "./components/ContactsPerson/index.js";
import "./components/CookieDisclaimer/index.js";
import "./components/Captcha/index.js";

// //sections
import "./sections/newsSlider/index.js";
import "./sections/otherServices/index.js";
import "./sections/filter/index.js";
import "./sections/certificates/index.js";
import "./sections/reviews/index.js";
